import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getActivityList, getChannelOptionList, changeActivityStatus, saveActivity, getAllCourseOptionList } from '@/api/exchange';
import { getEnabledCampList, getEnabledTermList, getEnabledColumnList } from '@/api/student';
const validateNumberHandler = (min, max, msg) => (_, value, cb) => {
    if (Number(value) < min || Number(value) > max) {
        cb(new Error(msg));
    }
    else {
        cb();
    }
};
let ExchangeManage = class ExchangeManage extends Vue {
    constructor() {
        super(...arguments);
        this.$refs = {};
        this.tabs = '1';
        this.pageNo = 1;
        this.total = 0;
        this.pageSize = 20;
        this.tableData = [];
        this.search = {
            channelId: '-1',
            createTime: [],
            activityStatus: '-1',
            keyword: '',
            searchType: 1 // 1活动名称 2活动ID
        };
        this.today = new Date(new Date().toLocaleDateString());
        this.channelOptions = [];
        this.courseOptions = [];
        this.columnList = [];
        this.courseList = [];
        this.option = [];
        this.props = {
            lazy: true,
            lazyLoad: async (node, resolve) => {
                const { level } = node;
                if (level <= 1) {
                    let nodes = level == 0 ? await this.getCampList() : await this.getTermList(node.value);
                    resolve(nodes);
                }
                else {
                    resolve([]);
                }
            }
        };
        this.activityCreator = {
            isVisible: false,
            isLoading: false,
            content: {
                id: '',
                title: '',
                channelVal: '',
                quantity: '',
                validDate: '',
                comment: '',
                courseId: '',
                type: 1,
                courseIdList: []
            },
            validateRules: {
                title: [
                    {
                        validator: (_, value, cb) => {
                            if (value.trim() === '') {
                                cb(new Error('请输入活动名称'));
                            }
                            else if (value.length > 20) {
                                cb(new Error('限20字符以内'));
                            }
                            else {
                                cb();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                channelVal: [
                    { required: true, message: '请选择渠道名称', trigger: 'change' },
                ],
                quantity: [
                    {
                        required: true,
                        message: '请输入兑换码数量',
                        trigger: 'blur',
                    },
                    {
                        validator: validateNumberHandler(1, 10000, '兑换码数量需为1-10000的整数'),
                        trigger: 'blur',
                    },
                ],
                // courseId: [
                // 	{ required: true, message: '请选择课程', trigger: 'change' },
                // ],
                comment: [{ max: 100, message: '限100字符以内', trigger: 'blur' }],
            },
        };
    }
    created() {
        this.getChannelOption();
        this.getCourseOption();
        this.getColumnList();
        this.getList();
    }
    async getCampList() {
        let res = await getEnabledCampList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.title,
                value: item.id,
                leaf: false,
            });
        });
        return list;
    }
    async getTermList(id) {
        let res = await getEnabledTermList(id);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.name,
                value: item.id,
                leaf: true,
            });
        });
        this.courseList = list;
        return list;
    }
    async getColumnList() {
        let res = await getEnabledColumnList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.columnList = res.data.data || [];
    }
    onChangeType(val) {
        this.activityCreator.content.courseId = '';
    }
    onSearch() {
        this.pageNo = 1;
        this.getList();
    }
    getChannelOption() {
        getChannelOptionList().then((res) => {
            if (res.data.status === 200) {
                this.channelOptions = res.data.data || [];
            }
            else {
                this.channelOptions = [];
            }
        });
    }
    getCourseOption() {
        getAllCourseOptionList().then((res) => {
            if (res.data.status === 200) {
                this.courseOptions = res.data.data.list || [];
            }
            else {
                this.courseOptions = [];
            }
        });
    }
    getList() {
        let data = {
            pageNo: this.pageNo,
            // pageSize: this.pageSize, 楚炎说由他那边控制
            keyword: this.search.keyword,
            activityStatus: this.search.activityStatus,
            channelId: this.search.channelId,
            searchType: this.search.searchType,
            createTimeStart: this.search.createTime ? this.search.createTime[0] : '',
            createTimeEnd: this.search.createTime ? this.search.createTime[1] : '',
        };
        getActivityList(data).then((res) => {
            if (res.data.status === 200) {
                this.tableData = res.data.data.list;
                this.pageSize = Number(res.data.data.pageSize);
                this.total = Number(res.data.data.total);
                this.pageNo = Number(res.data.data.pageNum);
            }
            else {
                // this.$message.error(res.data.msg);
                this.tableData = [];
                this.pageNo = 1;
                this.total = 0;
            }
        });
    }
    handleClick(tabs) {
        this.tabs = tabs.name;
        this.pageNo = 1;
        this.getList();
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    onExport(id) {
        this.$confirm('是否导出该列表？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            window.open(`/courseAdmin/redeem/activity/export?id=${id}`);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onChangeStatus(props) {
        let msg = `是否${props.activityStatus == 1 ? '停用' : '启用'}该活动？`;
        this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                id: props.id,
                status: props.activityStatus == 1 ? 2 : 1
            };
            changeActivityStatus(data).then((res) => {
                if (res.data.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.getList();
                }
            });
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onJumpExchange(id) {
        this.onJump(id);
    }
    onAddActivity() {
        this.activityCreator.isVisible = true;
    }
    onAddCourse() {
        if (!this.activityCreator.content.courseId || this.activityCreator.content.courseId.length === 0) {
            this.$message.error('请选择课程');
            return;
        }
        let courseId = this.activityCreator.content.type == 1 ? this.activityCreator.content.courseId[1] : this.activityCreator.content.courseId;
        let checked = this.activityCreator.content.courseIdList.filter((item) => { return courseId === item.value; });
        if (checked.length > 0) {
            this.$message.error('已添加过此课程');
            return;
        }
        if (this.activityCreator.content.type === 1) {
            let data = this.courseList.filter((item) => { return courseId === item.value; });
            this.activityCreator.content.courseIdList.push(data[0]);
            this.courseList = [];
            this.option = [];
        }
        else {
            let chooseData = this.columnList.filter((item) => { return courseId === item.id; });
            let data = {
                label: chooseData[0].name,
                value: chooseData[0].id
            };
            this.activityCreator.content.courseIdList.push(data);
        }
        this.activityCreator.content.courseId = '';
    }
    handleCloseTag(idx) {
        this.activityCreator.content.courseIdList.splice(idx, 1);
    }
    handleActivitySave() {
        console.log(this.activityCreator);
        if (this.activityCreator.content.title === '') {
            this.$message.error('请输入活动名称');
            return;
        }
        if (this.activityCreator.content.channelVal === '') {
            this.$message.error('请选择渠道名称');
            return;
        }
        if (this.activityCreator.content.quantity === '') {
            this.$message.error('请输入兑换码数量');
            return;
        }
        if (!/\d+/.test(this.activityCreator.content.quantity)) {
            this.$message.error('兑换码数量需为1-10000的整数');
            return;
        }
        if (this.activityCreator.content.quantity < 1 || this.activityCreator.content.quantity > 10000) {
            this.$message.error('兑换码数量需为1-10000的整数');
            return;
        }
        if (this.activityCreator.content.courseIdList.length === 0) {
            this.$message.error('请选择课程');
            return;
        }
        this.$confirm('创建后，活动信息将不可更改，确认按已填写信息创建活动吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let courseIdList = this.activityCreator.content.courseIdList.map((item) => { return item.value; });
            let data = {
                activityName: this.activityCreator.content.title,
                channelId: this.activityCreator.content.channelVal,
                validDate: this.activityCreator.content.validDate,
                description: this.activityCreator.content.comment,
                codeCounter: this.activityCreator.content.quantity,
                courseIds: courseIdList.join(',')
            };
            let headers = {
                email: localStorage.getItem('email') || '',
            };
            saveActivity(data, headers).then((res) => {
                if (res.data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: '创建成功'
                    });
                    this.getList();
                    this.closeActivityCreator();
                }
            });
        }).catch(() => {
        });
    }
    closeActivityCreator() {
        this.activityCreator.isVisible = false;
        this.activityCreator.isLoading = false;
        this.activityCreator.content = {
            id: '',
            title: '',
            channelVal: '',
            quantity: '',
            validityTime: '',
            comment: '',
            courseId: '',
            courseIdList: []
        };
        this.$refs.activityCreateForm.clearValidate();
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], ExchangeManage.prototype, "onJump", void 0);
ExchangeManage = tslib_1.__decorate([
    Component({
        filters: {
            format(time, fmtStr) {
                if (!time) {
                    return '-';
                }
                let date = new Date(time);
                let fmt = fmtStr ? fmtStr : 'yyyy-MM-dd hh:mm:ss';
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                var o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                };
                for (var k in o) {
                    if (new RegExp(`(${k})`).test(fmt)) {
                        var str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                    }
                }
                return fmt;
            }
        },
    })
], ExchangeManage);
export default ExchangeManage;
